/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linktolisting2Inputs */

const en_linktolisting2 = /** @type {(inputs: Linktolisting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to Listing`)
};

const de_linktolisting2 = /** @type {(inputs: Linktolisting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Ort verknüpfen`)
};

/**
* | output |
* | --- |
* | "Link to Listing" |
*
* @param {Linktolisting2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const linktolisting2 = /** @type {((inputs?: Linktolisting2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linktolisting2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_linktolisting2(inputs)
	return de_linktolisting2(inputs)
});
export { linktolisting2 as "linkToListing" }